import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export interface Props {
  twoColumnDescription: {
    header?: string;
    description?: string;
    title1?: string;
    descList1?: {
      desc?: string;
    }[];
    title2?: string;
    descList2?: {
      desc?: string;
    }[];
    applyCta?: {
      label?: string;
      url?: string;
    };
    learnMoreCta?: {
      label?: string;
      url?: string;
    };
  };
  bottomSection?: {
    enableDivider?: boolean;
    image?: {
      url?: string;
      alt?: string;
    };
    title?: string;
    desc?: string;
    cta?: {
      label?: string;
      url?: string;
    };
  };
}

const propsSchema: PropsSchemaList = [
  {
    key: 'twoColumnDescription',
    label: 'Two Column Description',
    type: types.OBJECT,
    children: [
      {
        key: 'header',
        label: 'Header',
        type: types.TEXT,
      },
      {
        key: 'description',
        label: 'Description',
        type: types.TEXT,
      },
      {
        key: 'title1',
        label: 'Title 1',
        type: types.TEXT,
      },
      {
        key: 'descList1',
        label: 'Description List 1',
        type: types.ARRAY,
        children: [
          {
            key: 'desc',
            label: 'Description',
            type: types.TEXT,
          }
        ]
      },
      {
        key: 'title2',
        label: 'Title 2',
        type: types.TEXT,
      },
      {
        key: 'descList2',
        label: 'Description List 2',
        type: types.ARRAY,
        children: [
          {
            key: 'desc',
            label: 'Description',
            type: types.TEXT,
          }
        ]
      },
      {
        key: 'applyCta',
        label: 'Apply CTA',
        type: types.OBJECT,
        children: [
          {
            key: 'label',
            label: 'Label',
            type: types.TEXT,
          },
          {
            key: 'url',
            label: 'URL',
            type: types.TEXT,
          },
        ]
      },
      {
        key: 'learnMoreCta',
        label: 'Learn More CTA',
        type: types.OBJECT,
        children: [
          {
            key: 'label',
            label: 'Label',
            type: types.TEXT,
          },
          {
            key: 'url',
            label: 'URL',
            type: types.TEXT,
          },
        ]
      },
    ]
  },
  {
    key: 'bottomSection',
    label: 'Bottom Section',
    type: types.OBJECT,
    children: [
      {
        key: 'enableDivider',
        label: 'Enable Divider',
        type: types.BOOLEAN,
      },
      {
        key: 'image',
        label: 'Image',
        type: types.OBJECT,
        children: [
          {
            key: 'url',
            label: 'URL',
            type: types.S3_ASSET_URL,
          },
          {
            key: 'alt',
            label: 'Image Alternative Text (A brief description of the image to optimize search engine visibility)',
            type: types.TEXT,
          },
        ]
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
      },
      {
        key: 'desc',
        label: 'Description',
        type: types.TEXT,
      },
      {
        key: 'cta',
        label: 'CTA',
        type: types.OBJECT,
        children: [
          {
            key: 'label',
            label: 'Label',
            type: types.TEXT,
          },
          {
            key: 'url',
            label: 'URL',
            type: types.TEXT,
          },
        ]
      },
    ]
  },
];

const defaultProps: Props = {
  twoColumnDescription: {
    header: `Apply to become FTO, Join to Co-Creation Open Platform`,
    description: `FPO (Futurist Product Officer): FPO is invited to deeply engaging in the entire process that features product definition, design, development and testing via an open platform where FF interacts with its user product experts. FPO helps identify user experience bugs in apps, offers improvement recommendations, provides valuable insights for better product experience, and contributes to the product power upgrade with quick reactions to market needs. This in-depth product definition process is aimed to jointly create products that best embody Ultimate AI Techluxury.`,
    title1: 'Qualifications:',
    descList1: [
      {
        desc: `Qualified candidates have a strong sense of mission for future transformations in the mobility ecosystem and are willing to play a part;`,
      },
      {
        desc: `Excellent market insight, strong interest and demand for product upgrades and improvements in the mobility ecosystem;`,
      },
      {
        desc: `Mobility ecosystem enthusiasts with a strong desire to experience the world's most advanced products;`,
      },
      {
        desc: `Foresight into the development trends of mobility ecosystem products including luxury vehicles, yachts, aircraft, etc.`,
      },
      {
        desc: `5+ years of experience in using premium mobility products;`,
      },
      {
        desc: `Comfortable in using FF products as one of the main means of daily transportation.`,
      },
    ],
    title2: 'Preferred experience:',
    descList2: [
      {
        desc: `Those who can frequently participate in product power improvement project are preferred;`,
      },
      {
        desc: `Independent experience in mobility ecosystem product R&D, vehicle collection, or vehicle modification industry is preferred;`,
      },
      {
        desc: `Proficient in global mobility ecosystem market trends and consumer demands.`,
      }
    ],
    applyCta: {
      label: 'Apply Now',
      url: 'https://www.ff.com/us/fto',
    },
    learnMoreCta: {
      label: 'Learn More',
      url: 'https://www.ff.com/us/fto',
    },
  },
  bottomSection: {
    enableDivider: true,
    image: {
      url: 'https://genesis-cdn.ff.com/assets/labs/original/Frame-1.png',
      alt: '',
    },
    title: `Try FF's latest experiments in Labs`,
    desc: `Collaborate in pioneering experiments to co-create the next wave of technological advancements.`,
    cta: {
      label: 'Learn More',
      url: 'https://www.ff.com',
    },
  },
};

export default {
  title: 'Two Column Description',
  id: 'TwoColumnDescription',
  propsSchema,
  defaultProps,
}
